import business from '@/utils/business'
export function Wxlist(data){
	return business.post('/client-employee/wx-list', data)
}

export function Wxmodify(data){
	return business.post('/client-employee/wx-modify', data)
}

export function ModifyX(data){
	return business.post('/client-employee/modify', data)
}


export function WxEmpAdd(data){
	return business.post('/client-employee/wx-add', data)
}





// WEBPACK FOOTER //
// ./src/api/Hremployee.js